export const environment = {
  production: true,
  cloudBasePath: 'https://d5sjelprrdni.cloudfront.net/git',
  translationsPath: 'https://d5sjelprrdni.cloudfront.net/template/i18n/halo/',
  servicePath: 'https://www.halo.fitness/lfservice/api',
  currentHostPath: 'https://www.halo.fitness/web',
  oamHostPath: 'https://oam.lifefitness.com',
  assetsPath: './assets',
  IPstackKey: '35d3e627c464cf7ef5996734521adea5',
  SSOformAuthRedirectionUrl: 'https://oam.lifefitness.com/oam/server/authentication',
  ssoPartsUrl: 'https://external-iprd.lifefitness.com',
  amplitudeAPI: '321b1ebb6fff1e2f8b34947f533d26ca',
  membrHostPath: 'https://prod-api.membraws.com/api/lfconnect/redirect',
  appEngineServiceBasePath: 'https://register-equipment-dot-lfco-qa-191202.appspot.com',
  s3CloudBasePath: 'https://web-static.halo.fitness',
  tncBasePath: 'https://d2rphhwi1n9zjn.cloudfront.net/template',
  haloWebCloudBasePath: 'https://d2rphhwi1n9zjn.cloudfront.net',
  retentionUrl: 'https://cdn.fitconnect.io/lf/index.html',
  pearStudioURL: 'https://lf-studio.pearsports.com/halo-signin?token=',
  pearBuilderURL: 'https://lf-pro.pearsports.com/halo-signin?token=',
  gcpServicePath: 'https://springboot-haloweb-release-rn5ozzze3a-uc.a.run.app/api/v1',
  zendeskURL: 'https://lifefitness9512.zendesk.com/hc/en-us/articles/6916317796887',
  apigeeCMSUrl: 'https://api.halo.fitness/managerapi/cms/v4',
  apigeeCMSTempUrl: 'https://us-central1-servicenotices-dev.cloudfunctions.net',
  apiKey: '3yXBN3MQ6APKA1c3BShx4gwmKpWQJne4',
  envkey_mux: '1uii4h7shdi9cf4dpahpjlpkv',
  gcpBasePath: 'https://prod-webapi.halo.fitness',
  assetsUrl: 'https://dev-halo5app1.halo.fitness/assets',
  fcConnectHostPath: 'https://facility.lifefitness.com/web/dashboard',
  fcConnectDownloadSoftwarePath: 'https://facility.lifefitness.com/static-apps/download-software',
};
